import { overParseJson, checkAttendantAndFetch } from '../utils/requestUtils';

const GET_FILES = 'https://afiliados.uol.com.br/api/listFilesByParent.html?idtParent=';
const HTTP_ERROR = 'HTTP_ERROR';

class FilesApi {
  static async getFilesByIdtParent(idtParent) {
    try {
      const fetchResponse = await checkAttendantAndFetch(`${GET_FILES}${idtParent}`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          // eslint-disable-next-line quote-props
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      });

      const text = await fetchResponse.text();
      const data = await overParseJson(text);

      if (fetchResponse.status !== 200) {
        const error = new Error(data.error);
        error.code = HTTP_ERROR;
        error.status = fetchResponse.status;
        throw error;
      }
      return data;
    } catch (error) {
      throw error;
    }
  }
}

export default FilesApi;
